import { AppDispatch } from "@Reducers/index";
import axiosWrapper from "@AxiosWrapper";
import type { Exact } from "@Helpers/types/exact";
import { setCurrencyDetails } from "../reducers/currency";
import type {
  GetSymbolsDataRequest,
  DeleteCurrencyRequest,
  SaveSelectedCurrencyRequest,
  GetDefaultCurrencyDetailForProjectLevelRequest,
} from "@ServerTypes/currency/currency.schema";

export const getSymbolsData = async <T extends Exact<GetSymbolsDataRequest, T>>(data: T) => {
  const response = await axiosWrapper.api.post("/currency/getSymbolsData", data);
  return response;
};
export const DeleteCurrencyData = async <T extends Exact<DeleteCurrencyRequest, T>>(data: T) => {
  const response = await axiosWrapper.api.post("/currency/deleteCurrencyData", data);
  return response;
};
export const saveSelectedCurrencyData = async <T extends Exact<SaveSelectedCurrencyRequest, T>>(data: T) => {
  const response = await axiosWrapper.api.post("/currency/saveSelectedCurrencyData", data);
  return response;
};

export const getDefaultCurrencyDetailForProjectLevel = async <
  T extends Exact<GetDefaultCurrencyDetailForProjectLevelRequest, T>,
>(
  data: T,
) => {
  const response = await axiosWrapper.api.post("/currency/getDefaultCurrencyDetailForProjectLevel", data);
  return response;
};
export const getCurrencyData =
  <T extends Exact<GetDefaultCurrencyDetailForProjectLevelRequest, T>>(data: T) =>
  async (dispatch: AppDispatch) => {
    const response = await axiosWrapper.api.post("/currency/getDefaultCurrencyDetailForProjectLevel", data);

    if (response.data.status) {
      const currencyObj = {
        ...(response.data.currencyDetail !== undefined && { currencyDetail: response.data.currencyDetail }),
        ...(response.data.symbolDetail !== undefined && { symbolDetail: response.data.symbolDetail }),
      };
      dispatch(setCurrencyDetails(currencyObj));
    }
  };
